import React from 'react'
import cx from 'classnames'
import { BaseImage } from 'components/common/Image'
import { presetStates } from './constants'

const EmptyView = React.memo((props) => {
  const presetState = presetStates[props.type] || presetStates.default
  const { image, caption, buttonText } = Object.assign({}, presetState, props)

  return (
    <div className={cx('flex flex-col items-center justify-center', props.className)}>
      <BaseImage src={image} className="h-36 w-36 object-contain lg:h-48 lg:w-48" />
      <h5 className="text-xs font-medium text-gray-500 lg:text-sm">{caption}</h5>
      {!!buttonText && (
        <button className="button-primary mt-10 h-11 rounded px-10 text-sm font-medium" onClick={props.onButtonClick}>
          {buttonText}
        </button>
      )}
    </div>
  )
})

EmptyView.displayName = 'EmptyView'

export default EmptyView
